import { useEffect, useState } from "react";
import Image from "next/image";
import { CommerceContentWrapper } from "./CommerceContent.style";
import { validateEmail, validatePhone } from "@/utils/regexs";
import { Loader } from "@/components/Loader/Loader";

const CommerceContent = ({ data, formData }: any) => {
    const [emailSent, setEmailSent] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [emptyFieldError, setEmptyFieldError] = useState<boolean>(false);
    const [body, setBody] = useState<{
        name: string;
        company: string;
        email: string;
        phone: string;
        business_type: string;
        location: string;
        accept_privacy: string;
        accept_subscription: string;
    }>({
        name: "",
        company: "",
        email: "",
        phone: "",
        business_type: "",
        location: "",
        accept_privacy: "No",
        accept_subscription: "No",
    });
    const [emailError, setEmailError] = useState<string | null>(null);
    const [phoneError, setPhoneError] = useState<string | null>(null);
    const [requestError, setRequestError] = useState<boolean>(false);

    const validateForm = (e: any) => {
        e.preventDefault();
        if (
            body?.name?.length &&
            body?.company?.length &&
            body?.phone?.length &&
            body?.email?.length &&
            body?.business_type?.length &&
            body?.location?.length &&
            body?.accept_privacy === "Si" &&
            !emailError &&
            !phoneError
        ) {
            setEmptyFieldError(false);
            handleSubmit(e);
        } else {
            setEmptyFieldError(true);
        }
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        try {
            setLoading(true);
            const response = await fetch("/api/send-email", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

            if (response.status === 200) {
                setBody({
                    name: "",
                    company: "",
                    email: "",
                    phone: "",
                    business_type: "",
                    location: "",
                    accept_privacy: "",
                    accept_subscription: "",
                });
                setEmailSent(true);
            } else if (response.status == 500) {
                console.log("Error");
                setRequestError(true);
                setBody({
                    name: "",
                    company: "",
                    email: "",
                    phone: "",
                    business_type: "",
                    location: "",
                    accept_privacy: "",
                    accept_subscription: "",
                });
            }
            window.scrollTo({
                top: 0,
                behavior: "auto",
            });
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (body?.email?.length) {
            if (validateEmail(body?.email)) {
                setEmailError(null);
            } else {
                setEmailError(formData?.form?.inputs?.email?.error);
            }
        } else {
            setEmailError(null);
        }
        if (body?.phone?.length) {
            if (validatePhone(body?.phone)) {
                setPhoneError(null);
            } else {
                setPhoneError(formData?.form?.inputs?.phone?.error);
            }
        } else {
            setPhoneError(null);
        }
    }, [body.email, body.phone]);

    const handleInputChange = (e: any) => {
        if (e.target.name === "accept_privacy" || e.target.name === "accept_subscription") {
            if (e.target.checked) {
                setBody({
                    ...body,
                    [e.target.name]: "Si",
                });
            } else {
                setBody({
                    ...body,
                    [e.target.name]: "No",
                });
            }
        } else {
            setBody({
                ...body,
                [e.target.name]: e.target.value.trimStart(),
            });
        }
    };
    return (
        <CommerceContentWrapper>
            <div className="hero">
                <Image
                    src={`${process.env.NEXT_PUBLIC_STRAPI_URL}${data?.hero_image?.data?.attributes?.url}` || "/"}
                    alt={data?.hero_image?.data?.attributes?.alt}
                    layout="fill"
                    style={{ objectFit: "cover" }}
                />
                <div className="hero_text">
                    <h2>{data?.pretitle}</h2>
                    <h1 dangerouslySetInnerHTML={{ __html: data?.title.replace("Y", "Y&nbsp;") }} />
                </div>
            </div>
            {loading ? (
                <Loader />
            ) : emailSent ? (
                <div className="success">
                    <h3>{formData?.success?.message}</h3>
                    <button onClick={() => setEmailSent(false)}>{formData?.success?.button}</button>
                </div>
            ) : requestError ? (
                <div className="success">
                    <h3>{formData?.error?.message}</h3>
                    <button onClick={() => setRequestError(false)}>{formData?.error?.button}</button>
                </div>
            ) : (
                <>
                    <h3>{data?.hero_description}</h3>
                    <form>
                        <div className="top_inputs">
                            <div className="right">
                                <label>{formData?.form?.inputs?.name?.label}</label>
                                <input
                                    placeholder={formData?.form?.inputs?.name?.placeholder}
                                    name="name"
                                    maxLength={30}
                                    onChange={handleInputChange}
                                />
                                <label>{formData?.form?.inputs?.email?.label}</label>
                                <input
                                    placeholder={formData?.form?.inputs?.email?.placeholder}
                                    name="email"
                                    maxLength={50}
                                    onChange={handleInputChange}
                                />
                                <span className="error">{emailError}</span>
                            </div>
                            <div className="left">
                                <label>{formData?.form?.inputs?.company?.label}</label>
                                <input
                                    placeholder={formData?.form?.inputs?.company?.placeholder}
                                    name="company"
                                    maxLength={30}
                                    onChange={handleInputChange}
                                />
                                <label>{formData?.form?.inputs?.phone?.label}</label>
                                <input
                                    placeholder={formData?.form?.inputs?.phone?.placeholder}
                                    name="phone"
                                    maxLength={20}
                                    onChange={handleInputChange}
                                />
                                <span className="error">{phoneError}</span>
                            </div>
                        </div>
                        <div className="lower_inputs">
                            <label>{formData?.form?.inputs?.type?.label}</label>
                            <input name="business_type" onChange={handleInputChange} />
                            <label>{formData?.form?.inputs?.location?.label}</label>
                            <input name="location" onChange={handleInputChange} />
                            <p>{data?.notice_text}</p>
                            <div className="checkbox_container">
                                {" "}
                                <input type="checkbox" name="accept_privacy" onChange={handleInputChange} /> <label>{data?.privacy_checkbox}</label>
                            </div>
                            <div className="checkbox_container">
                                {" "}
                                <input type="checkbox" name="accept_subscription" onChange={handleInputChange} />{" "}
                                <label>{data?.subscription_checkbox}</label>
                            </div>
                        </div>
                        {emptyFieldError && (
                            <p style={{ marginTop: 10 }} className="error">
                                Por favor complete los campos indicados para continuar
                            </p>
                        )}
                        <button onClick={validateForm}>{formData?.form?.button}</button>
                    </form>
                </>
            )}
        </CommerceContentWrapper>
    );
};

export { CommerceContent };
